import * as yup from "yup";

const guardar = yup.object().shape({
  fechaSolicitud: yup.string().required(),

  solicitante: yup.object({
    id: yup.number().required().min(1),
  }),

  unidad: yup.object({
    id: yup.number().required().min(1),
  }),

  patio: yup
    .object({
      id: yup.number().min(1),
    })
    .nullable()
    .notRequired()
    .default(null),

  tipoServicio: yup
    .object({
      id: yup.number().required().min(1),
    })
    .nullable()
    .required(),

  fallas: yup.array().of(
    yup.object().shape({
      descripcion: yup
        .string()
        .trim()
        .required("La descripción es requerida"),
    }),
  ),
});

const solicitudServicioValidacionEsquema = {
  guardar,
};

export default solicitudServicioValidacionEsquema;